// extracted by mini-css-extract-plugin
module.exports = {"setPasswordErrors":"SetPassword_setPasswordErrors__2PRQV"};